export const CIS_COUNTRIES = [
  'RU',
  'AM',
  'AZ',
  'BY',
  'KZ',
  'KG',
  'MD',
  'TJ',
  'TM',
  'UA',
  'UZ',
  'GE',
  'LV',
  'LT',
  'EE',
];